import { api } from "./client"

export type AdminSettingsValues = {
  ai_provider: "auto" | "gemini" | "claude"
  ai_model_gemini: string
  ai_model_claude: string
  ai_temperature: number
  resend_from: string | null
  app_base_url: string | null
}

export type AdminSettings = {
  values: AdminSettingsValues
  options: {
    ai_provider: string[]
    ai_model_gemini: string[]
    ai_model_claude: string[]
  }
  env_status: Record<string, boolean>
}

export type AdminSettingsUpdate = Partial<AdminSettingsValues>

export const adminApi = {
  getSettings: () => api<AdminSettings>("/admin/settings"),
  updateSettings: (body: AdminSettingsUpdate) =>
    api<{ ok: boolean }>("/admin/settings", { method: "PUT", body }),
}
